import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.9.1_better-sqlite3@11.7.0_drizzle-orm@0.3_aggtkidl3zyij3boixs2tzo4rq/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.9.1_better-sqlite3@11.7.0_drizzle-orm@0.3_aggtkidl3zyij3boixs2tzo4rq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-if-not-authenticated": () => import("/opt/buildhome/repo/middleware/RedirectIfNotAuthenticated.ts")
}